'use client';

import { c as _c } from "react/compiler-runtime";
import { XIcon } from 'lucide-react';
import { useTranslations } from 'next-intl';
import { useState } from 'react';
import IconSort from '@/components/assets/icon_sort.svg';
import { Sheet, SheetClose, SheetContent, SheetHeader, SheetTitle, SheetTrigger } from '@/components/ui/sheet';
import ViverseButton from '@/components/ViverseButton';
import ViverseRadio from '@/components/ViverseRadio';
import { useUAContext } from '@/context/UAContext';
import { cn } from '@/lib/utils';
import { SortValue } from '@/types/search';
type SortOption = {
  value: SortValue;
  label: string;
};
type SortBySheetProps = {
  sortBy: string;
  onSortChange: (value: SortValue) => void;
  sortOptions: SortOption[];
  sortOption: SortOption | undefined;
};
export default function SortBySheet(t0) {
  const $ = _c(40);
  const {
    sortBy,
    onSortChange,
    sortOptions,
    sortOption
  } = t0;
  const t = useTranslations();
  const [open, setOpen] = useState(false);
  const {
    isMobileApp
  } = useUAContext();
  let t1;
  if ($[0] !== onSortChange) {
    t1 = value => {
      onSortChange(value as SortValue);
      setOpen(false);
    };
    $[0] = onSortChange;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const handleValueChange = t1;
  let t2;
  if ($[2] !== open) {
    t2 = cn("flex min-w-fit items-center justify-between gap-2", {
      "bg-vive-primary-70 text-white": open
    });
    $[2] = open;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const t3 = open ? "fill-white" : "fill-vive-primary-20";
  let t4;
  if ($[4] !== t3) {
    t4 = cn("size-4 shrink-0", t3);
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t4) {
    t5 = <IconSort className={t4} />;
    $[6] = t4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  const t6 = sortOption?.label;
  let t7;
  if ($[8] !== t2 || $[9] !== t5 || $[10] !== t6) {
    t7 = <SheetTrigger asChild={true}><ViverseButton variant="icon3" size="silent2" className={t2}>{t5}{t6}</ViverseButton></SheetTrigger>;
    $[8] = t2;
    $[9] = t5;
    $[10] = t6;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <XIcon className="size-6" />;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] !== t) {
    t9 = t("worlds-landing.search.sort.close");
    $[13] = t;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  let t10;
  if ($[15] !== t9) {
    t10 = <SheetClose>{t8}<span className="sr-only">{t9}</span></SheetClose>;
    $[15] = t9;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  let t11;
  if ($[17] !== t) {
    t11 = t("worlds-landing.search.sort.title");
    $[17] = t;
    $[18] = t11;
  } else {
    t11 = $[18];
  }
  let t12;
  if ($[19] !== t11) {
    t12 = <SheetTitle className="header-4 text-vive-primary-20">{t11}</SheetTitle>;
    $[19] = t11;
    $[20] = t12;
  } else {
    t12 = $[20];
  }
  let t13;
  if ($[21] !== t10 || $[22] !== t12) {
    t13 = <SheetHeader className="flex flex-row items-center gap-4">{t10}{t12}</SheetHeader>;
    $[21] = t10;
    $[22] = t12;
    $[23] = t13;
  } else {
    t13 = $[23];
  }
  const t14 = isMobileApp && "pb-20";
  let t15;
  if ($[24] !== t14) {
    t15 = cn("px-4 pb-4", t14);
    $[24] = t14;
    $[25] = t15;
  } else {
    t15 = $[25];
  }
  let t16;
  if ($[26] !== handleValueChange || $[27] !== sortBy || $[28] !== sortOptions) {
    t16 = <ViverseRadio options={sortOptions} value={sortBy} onValueChange={handleValueChange} className="flex flex-col gap-4" wrapperClassName="w-full" optionRowClassName="py-0" labelClassName="text-sm text-white pl-4" />;
    $[26] = handleValueChange;
    $[27] = sortBy;
    $[28] = sortOptions;
    $[29] = t16;
  } else {
    t16 = $[29];
  }
  let t17;
  if ($[30] !== t15 || $[31] !== t16) {
    t17 = <div className={t15}>{t16}</div>;
    $[30] = t15;
    $[31] = t16;
    $[32] = t17;
  } else {
    t17 = $[32];
  }
  let t18;
  if ($[33] !== t13 || $[34] !== t17) {
    t18 = <SheetContent side="bottom" closeButtonClassName="hidden" className="z-overlay gap-2 rounded-t-[3px] border-none bg-[#212A3966] p-0 shadow-lg backdrop-blur-md">{t13}{t17}</SheetContent>;
    $[33] = t13;
    $[34] = t17;
    $[35] = t18;
  } else {
    t18 = $[35];
  }
  let t19;
  if ($[36] !== open || $[37] !== t18 || $[38] !== t7) {
    t19 = <Sheet open={open} onOpenChange={setOpen}>{t7}{t18}</Sheet>;
    $[36] = open;
    $[37] = t18;
    $[38] = t7;
    $[39] = t19;
  } else {
    t19 = $[39];
  }
  return t19;
}